function ActionCard({
  icon = "✨",
  title,
  description,
  actionLabel = "Open",
  onClick,
  secondaryAction = null,
}) {
  return (
    <div
      className="action-card"
      style={{
        background: "linear-gradient(180deg, #171717, #111)",
        border: "1px solid #262626",
        borderRadius: "18px",
        padding: "20px",
        boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
      }}
    >
      <div
        className="action-card__icon"
        style={{
          fontSize: "28px",
          lineHeight: 1,
          marginBottom: "14px",
        }}
      >
        {icon}
      </div>

      <h3
        className="action-card__title"
        style={{
          margin: "0 0 10px 0",
          fontSize: "18px",
        }}
      >
        {title}
      </h3>

      <p
        className="action-card__description"
        style={{
          margin: 0,
          color: "#cfcfcf",
          lineHeight: "1.7",
        }}
      >
        {description}
      </p>

      <div
        className="action-card__actions"
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: "16px",
        }}
      >
        <button onClick={onClick} style={primaryBtn} className="action-card__button">
          {actionLabel}
        </button>

        {secondaryAction}
      </div>
    </div>
  );
}

const primaryBtn = {
  padding: "12px 16px",
  border: "none",
  background: "#fff",
  color: "#000",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "bold",
};

export default ActionCard;
